export const isDisabled = (
  key: string,
  fieldValid: string,
  selectedCount: number,
  isDeclined: boolean,
  subUseCases: boolean,
  campaignId: boolean,
) => {
  const disabled =
    (selectedCount >= 5 && !fieldValid?.split(',').includes(key)) ||
    (isDeclined && !subUseCases && campaignId);
  return disabled;
};
